import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const MachineType = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "type", label: "Tipo", type: "text", required: true, displayForm: true, displayList: true },
    { key: "subtype", label: "Sub tipo", type: "text", required: true, displayForm: true, displayList: true },
    { key: "subsubtype", label: "Sub sub tipo", type: "text", required: true, displayForm: true, displayList: true },
  ];

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Tipos de maquinas
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList fields={fieldsConfig} tableName="machine_types" hasCheckbox={true} objectName={"machine type"} tabledescription={"Tipos de maquinas"}/>
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default MachineType;
